// This file was automatically generated from render.visitNote.alertFeed.html.
// Please don't edit this file by hand.

goog.provide('el8.template.render.visitNote.alertFeed');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.visitNote.alertFeed.cqm = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedItemId), '" data-id="', soy.$$escapeHtml(opt_data.item.id), '" class="alert-item el8FeedItemNoMinHeight"><div class="el8FeedItemNoDateContainer"><div class="el8CDSActionContainer"><ul class="el8ButtonContainer"><li class="el8ShortcutBarButtonItemFirst"><button class="el8button resolve-trigger el8ItemButton2 el8FirstButton">Address</button></li><li class="el8ShortcutBarButtonItemLast"><button class="el8button dismiss-trigger el8ItemButton2 el8LastButton">Dismiss</button></li></ul></div><p class="note-alert-feed-header">', (opt_data.showCdsDetails) ? '<a class="note-alert-item-trigger">' + soy.$$escapeHtml(opt_data.item.promptLabel) + '</a>' : soy.$$escapeHtml(opt_data.item.promptLabel), (opt_data.additionalCareGapContext) ? '<p class="el8CDSActionAdditionalCareGapContext el8CDSActionAdditionalCareGapContextCollapsed additional-context-trigger">' + soy.$$escapeHtml(opt_data.additionalCareGapContext) + '</p>' : '', '</div></li>');
  if (!opt_sb) return output.toString();
};
